import styled, { css } from 'styled-components/macro';
import { bool } from 'prop-types';

const Row = styled('tr')`
  ${({ enableHover }) =>
    enableHover &&
    css`
      &:hover {
        background: ${({ theme }) => theme.Sand};
      }
    `};
`;

export default Row;

Row.defaultProps = {
  enableHover: true,
};

Row.propTypes = {
  /** Should we show a hover state on this row or disable it? Hover is enabled by default */
  enableHover: bool,
};
